module.exports = __webpack_public_path__ + "img/3.70317987.png";